/* eslint-disable no-param-reassign */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import { ApiService } from "../services";
import { applyCouponCode, setGbCheckout } from "../store";
import { API_SUCCESS_CODES } from "../constants";

// eslint-disable-next-line import/prefer-default-export
export function useCheckoutMutation() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  return useMutation({
    mutationKey: ["get-checkout"],
    mutationFn: async ({ cart, shopDomain }) => {
      const parentUrl = window.location.href;
      const searchParams = new URLSearchParams(new URL(parentUrl).search);
      const utmKeys = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content"
      ];
      const utmParameters = [];
      utmKeys.forEach((key) => {
        const value = searchParams.get(key);
        if (value) utmParameters.push({ name: key, value });
      });

      const response = await ApiService.post(
        `${shopDomain}/checkout`,
        { cart, utm_parameters: utmParameters },
        user.authToken ? { authorization: `Bearer ${user.authToken}` } : {}
      );

      return response.data;
    },
    onSuccess: (response) => {
      dispatch(setGbCheckout(response));
    },
    retry: 2
  });
}

export const useApplyDiscountsMutation = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { user, order, cart } = useSelector((state) => state);

  return useMutation({
    mutationKey: ["apply-discounts"],
    mutationFn: async ({ loyaltyPoints, discountCode }) => {
      try {
        if (typeof loyaltyPoints !== "number") loyaltyPoints = undefined;

        if (typeof discountCode !== "string") discountCode = undefined;
        loyaltyPoints = Math.round(loyaltyPoints);
        const response = await ApiService.post(
          `${order.shopDomain}/order/${order.orderDetails.id}/apply-discounts`,
          { discountCode, loyaltyPoints },
          { authorization: `Bearer ${user.authToken}` }
        );

        if (!API_SUCCESS_CODES.includes(response.statusCode))
          throw Error("Invalid Coupon!");

        return { discountCode, ...response };
      } catch (error) {
        throw new Error(error.message || "Something went wrong!");
      }
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: ["get-redeemable-points", cart?.checkoutDetails?.checkoutId]
      });
      dispatch(applyCouponCode(response));
    }
  });
};
